import React, { useContext, useEffect, useState } from 'react'
import { AppSettings } from '../../config/app-settings'
import {
  Card,
  CardBody,
  CardFooter,
  CardHeader
} from '../../components/other/card/card'
import CampaignDropdown from '../../components/CampaignDropdown'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import TextArea from 'antd/es/input/TextArea'
import { useChangeCampaignMutation } from '../../redux/apis/linkManagement/changeGetLink/lMChangeGetLinkApiSlice'
import Loader from '../pages/loader'
import InsertionResultModal from '../../components/InsertionResultModal'

const ChangeLinksCampaign = React.memo(() => {
  const context = useContext(AppSettings)
  const [create, { isLoading }] = useChangeCampaignMutation()
  const [result, setResult] = useState(null)

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      urls: '',
      campaign: ''
    },

    validationSchema: Yup.object({
      urls: Yup.string().required('please Enter Urls'),
      campaign: Yup.string().required('please Enter Report Status')
    }),

    onSubmit: async values => {
      const urls = values.urls
        .split('\n')
        .map(url => url.trim())
        .filter(url => url)
      const data = {
        urls: urls,
        campaign: values.campaign
      }

      try {
        const res = await create(data)
        const resultData = res?.data ?? res?.error?.data ?? {}
        setResult(resultData)
        if (res?.data?.success) {
          validation.resetForm()
        }
      } catch (error) {
        console.error(error)
      }
    }
  })

  useEffect(() => {
    context.setAppHeaderNone(false)
    context.setAppSidebarNone(false)
    context.setAppContentClass('')
    context.setAppThemePanal(true)

    return () => {
      context.setAppHeaderNone(true)
      context.setAppSidebarNone(true)
      context.setAppContentClass('p-0')
      context.setAppThemePanal(false)
    }
  }, [context]) 

  return (
    <div>
      <Loader isLoading={isLoading} />
      <InsertionResultModal
        result={result}
        reportTitle='Change links campaign'
        onClose={() => setResult(null)}
      />
      <Card>
        <CardHeader>
          <p>Change Links campaign</p>
        </CardHeader>
        <CardBody>
          <CampaignDropdown
            onBlur={validation.handleBlur}
            onChange={e => {
              validation.setFieldValue('campaign', e)
            }}
            value={validation.values?.campaign}
            className='customSelect'
          />
          {validation.touched.campaign && validation.errors.campaign ? (
            <p className='text-danger'>{validation.errors.campaign}</p>
          ) : null}

          <div className=' mb-3 flex-1 customInput'>
            <label className="form-label">URLs (separated by new lines)</label>
            <TextArea
              type='text'
              name='urls'
              onChange={validation.handleChange}
              onBlur={validation.handleBlur}
              value={validation.values.urls}
              placeholder='Enter urls separated by new lines
              example:
              test.com
              test2.com
              test3.com
              '
              rows={15}
            />
            {validation.touched.urls && validation.errors.urls ? (
              <p className='text-danger'>{validation.errors.urls}</p>
            ) : null}
          </div>
        </CardBody>
        <CardFooter>
          <div className='flex justify-end gap-8'>
            <button
              onClick={() => {
                validation.handleSubmit()
              }}
              className='btn btn-theme'
            >
              Submit
            </button>
          </div>
        </CardFooter>
      </Card>
    </div>
  )
})

export default ChangeLinksCampaign
